/* PDP "You May Also Like" - SUGGESTED tab slider (10.10.26)
   Runs after the theme loads the product recommendations into the section
   (theme-v3.js calls window.initSwipers()). The slider markup comes from
   snippets/product-recommendation-swiper.liquid.

   Changes on 10.10.26:
   - The per-screen counts were the wrong way round: phones got the desktop
     count (4 per row) and desktop got the phone count (2). Now phones (<768px)
     show 2 per row and tablet/desktop (768px+) show 4. From 768px the theme's
     CSS already sizes each tile at a quarter of the row, so the slider must
     use 4 there too or it scrolls into empty space.
   - If Shopify recommends fewer than 4 products, the row is topped up to 4
     with products from the other tab (the custom collection), skipping the
     current product and anything already shown.
   - watchOverflow: when every product fits on screen the slider locks - no
     dragging, and the arrows are hidden.
   - Each slider only uses its own arrows, and an old slider is removed before
     a new one is made (initSwipers can run more than once). */
window.initSwipers = function () {
  const swiper_Sections = document.querySelectorAll('[data-swiper_id^="swiper__controls_swiper_related"]');

  if (!swiper_Sections.length) return;

  swiper_Sections.forEach(swiper_Section => {
    const slide_count = parseFloat(swiper_Section.dataset.slide_count) || 4;               // tablet + desktop
    const slide_count_mobile = parseFloat(swiper_Section.dataset.slide_count_mobile) || 2; // phones

    const container = swiper_Section.querySelector('.swiper__Container');
    if (!container) return;

    // Make sure there are at least 4 products (see cfTopUpSuggested below)
    cfTopUpSuggested(swiper_Section, slide_count);

    // Remove an earlier slider on the same element before making a new one
    if (container.swiper && typeof container.swiper.destroy === 'function') {
      container.swiper.destroy(true, true);
    }

    const pagination = swiper_Section.querySelector('.swiper-pagination');

    new Swiper(container, {
      freeMode: true,
      observer: true,
      observeParents: true,
      grabCursor: true,
      loop: false,
      watchOverflow: true, // lock the slider when everything fits
      preventClicks: true,
      preventClicksPropagation: true,
      pagination: pagination ? { el: pagination, clickable: true } : false,
      keyboard: { enabled: true },
      navigation: {
        nextEl: swiper_Section.querySelector('.swiper-button-next'),
        prevEl: swiper_Section.querySelector('.swiper-button-prev'),
      },
      initialSlide: 0,
      // Phones
      slidesPerView: slide_count_mobile,
      slidesPerGroup: slide_count_mobile,
      spaceBetween: 10,
      breakpoints: {
        // Tablet and desktop
        768: {
          slidesPerView: slide_count,
          slidesPerGroup: slide_count,
          spaceBetween: 10,
        },
      },
    });
  });
};

/* Top up the SUGGESTED row to `target` products using tiles from the other
   tab (custom collection) in the same section. Tiles are copied, and their
   ids are renamed so the size buttons of the copy and the original don't
   clash. */
function cfTopUpSuggested(swiper_Section, target) {
  const list = swiper_Section.querySelector('.swiper-wrapper');
  const section = swiper_Section.closest('.related__wrapper');
  if (!list || !section) return;

  // Product handle from the tile's product link
  const handleOf = el => {
    const link = el.querySelector('a[href*="/products/"]');
    const match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  const shown = new Set();
  const currentMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (currentMatch) shown.add(currentMatch[1]);

  let count = 0;
  list.querySelectorAll(':scope > .swiper-slide').forEach(slide => {
    count++;
    const handle = handleOf(slide);
    if (handle) shown.add(handle);
  });
  if (count >= target) return;

  const sources = section.querySelectorAll('.tabs__custom-collection .product-item');
  for (const source of sources) {
    if (count >= target) break;
    const handle = handleOf(source);
    if (!handle || shown.has(handle)) continue;

    const copy = source.cloneNode(true);
    // Drop the other slider's sizing/position so this slider can set its own
    copy.removeAttribute('style');
    copy.removeAttribute('aria-label');
    copy.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
    copy.classList.add('swiper-slide', 'cf-ymal-topup');
    // Unique ids so labels in the copy only control the copy's inputs
    copy.querySelectorAll('[id]').forEach(el => { if (el.id) el.id = el.id + '-cf-sugg'; });
    copy.querySelectorAll('label[for]').forEach(el => { el.setAttribute('for', el.getAttribute('for') + '-cf-sugg'); });

    list.appendChild(copy);
    shown.add(handle);
    count++;
  }
}

// Auto-run once on initial page load
document.addEventListener("DOMContentLoaded", () => {
  window.initSwipers();
});
